typedef {{ type }} {{ name }};
